/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui'
import { Link } from 'gatsby'

const FavIcons = ({path, ariaLabel, children}) => (
  <div
    sx={{
        width: 'fit-content',
        display: 'inline',
        backgroundColor: '#D6D6D6',
        ml: 2,
        borderRadius: '80px',
        p: '2',
        pl: '8px',
        pr: '8px',
        height: '34px',
        pt: '4px',
        "&:hover": {
        "backgroundColor": "#fff"
      }
    }}>
<a target='_blank' rel="noopener" sx={{ color: '#6F6F6F', }} href={path} aria-label={ariaLabel}>{children}</a>
    </div>
)

export default FavIcons
